import React, { Component } from 'react'
import { connect } from "react-redux"
import PropTypes from "prop-types"

import BarGraph from "visualizations/components/BarGraph"
import PieChart from "visualizations/components/PieChart"
import { toggleValue } from 'shared/imports/sharedHelperFunctions'

import { barPieProps } from "search-new/selectors"

export class BarPieWrapper extends Component {
    static propTypes = {
        // from ListViewDisplayWrapper
        uniqueFlvId: PropTypes.string.isRequired,
        uniqueVizSceneId: PropTypes.string.isRequired,
        vizFilterId: PropTypes.string,
        colorConfigs: PropTypes.object,
        // from containers/VisualizationDisplay/index
        data: PropTypes.object.isRequired,
        visualizationFilterValues: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isVisualizationLoading: PropTypes.bool.isRequired,
        isVisualizationDataEmpty: PropTypes.bool.isRequired,
        selectedValues: PropTypes.array.isRequired,
        storedGraphs: PropTypes.object.isRequired,
        // from components/VisualizationDisplay/index (modified)
        updateSelection: PropTypes.func.isRequired,
        // from barpie connet
        currentGraph: PropTypes.string,
        currentOnlyData: PropTypes.object,
    }

    updateGraph = (value) => {
        if (!this.props.vizFilterId) {
            return
        }

        const newSelectedValues = toggleValue(this.props.selectedValues, value)
        this.props.updateSelection(newSelectedValues)
    }

    render() {
        const Graph = (this.props.currentGraph === 'bar')
            ? BarGraph
            : PieChart

        return (
            <Graph
                data={this.props.currentOnlyData}
                updateGraph={this.updateGraph}
                selectedValues={this.props.selectedValues}
                isLoading={this.props.isVisualizationLoading}
                svgId={this.props.uniqueVizSceneId}
                colorConfigs={this.props.colorConfigs}
            />
        )
    }
}

export default connect(barPieProps, null)(BarPieWrapper)
